import useShareModal from '@/components/Record/ShareButton/useShareModal';
import { useTalkFlowShareList } from '@/hooks/apiHooks';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import useLayoutSize from '@/hooks/useLayoutSize';
import { LayoutType } from '@/constant/layout';
import { useTranslation } from 'react-i18next';
import ShareIcon from '@/public/icons/record/share.svg';
import { Button, styled } from '@mui/material';

const ShareButton = () => {
  const { openModal, ShareModal } = useShareModal();
  const { watch } = useFormContext<RecordFilter>();
  const { data } = useTalkFlowShareList(watch('docId'));
  const { isMobile } = useLayoutSize(LayoutType.DEFAULT);
  const { t } = useTranslation();

  const shareCount = data?.meta.totalCount ? data.meta.totalCount - 1 : 0;
  const shareText = t('{{n}}명에게 공유됨', { n: shareCount });

  return (
    <div>
      <StyledButton disableRipple onClick={openModal}>
        <ShareIcon />
        {isMobile ? (
          <strong>{shareCount}</strong>
        ) : (
          <span
            dangerouslySetInnerHTML={{
              __html: shareText.replace(/([\d.,]+)/g, '<strong>$&</strong>'),
            }}
          />
        )}
      </StyledButton>
      {ShareModal}
    </div>
  );
};

export default ShareButton;

const StyledButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 3px 8px;
  border-radius: 99px;
  border: 1px solid var(--dk-line, #e7e9ec);
  line-height: 18px;
  font-weight: 400;
  font-size: 12px;
  color: var(--dk-accent, #06c);
`;
